'use strict';

var _ = require('lodash');
var GridToolbarSystemStatusMarketReoptController = function GridToolbarSystemStatusMarketReoptController($scope) {
  $scope.selectedRows = [];
  $scope.isCancelButtonShow = false;
  $scope.onRowSelection = function (selectedRows) {
    $scope.isCancelButtonShow = selectedRows.length > 0 && _.every(selectedRows, isNewOptimization);
    $scope.selectedRows = selectedRows;
  };
  $scope.cancelOptimization = function () {
    $scope.$emit('system-reoptimization-status:cancel', $scope.selectedRows);
  };
  function isNewOptimization(row) {
    return !row.startDate;
  }
};
GridToolbarSystemStatusMarketReoptController.$inject = ['$scope'];
module.exports = GridToolbarSystemStatusMarketReoptController;